import React, { useState, useRef, useEffect } from 'react'
import Lottie from 'lottie-web'

const LottieTransitionLoader = ({ setLoadCounter, value, ticker, player, AnimationId, CanvasDisplay, onePxEquivalent }) => {

    const [CanvChar, setCanvChar] = useState(null)

    const refnew = useRef()

    const [chechState, setchechState] = useState(true)

    useEffect(() => {
        if (CanvChar) {
            if (sessionStorage.getItem("LoadCounter")) {
                let array = JSON.parse(sessionStorage.getItem("LoadCounter"));
                array.push(value.previewKey);
                sessionStorage.setItem("LoadCounter", JSON.stringify(array))
                setLoadCounter(array);
            }
        }
    }, [CanvChar])

    useEffect(() => {
        if (CanvChar != null && CanvasDisplay) {
            if (value.startPositionOnTimeline + value.startTransitionWidth < ticker && (value.startPositionOnTimeline + value.widthOnTimeline) > ticker) {
                let playedtime = ticker - value.startPositionOnTimeline//in px
                let jsonTotaltime = CanvChar.totalFrames
                let fm = CanvChar.frameRate;
                //console.log("fm", fm)
                let ms = (playedtime * onePxEquivalent) / 1000
                let playedFrame = ms * fm
                let Playon = null;

                if (playedFrame > jsonTotaltime) {
                    while (true) {
                        let start = playedFrame - jsonTotaltime
                        if (start < jsonTotaltime) {
                            Playon = start
                            break
                        } else {
                            playedFrame = start
                        }
                    }
                } else {
                    Playon = playedFrame
                }
                CanvChar.goToAndStop(Playon, true, AnimationId)
            }
            if (value.startPositionOnTimeline > ticker) {
                CanvChar.goToAndStop(0, true, AnimationId)
            }
        }
    }, [ticker])

    useEffect(() => {
        if (value.character_FilePath != undefined) {
            const data = Lottie.getRegisteredAnimations();
            for (let i = 0; i < data.length; i++) {
                if (data[i].name == AnimationId) {
                    Lottie.destroy(AnimationId)
                }
            }
            // Address as it is (it was lower-cased: a second download of the same file under
            // another name, and a missing file on servers where names are case-sensitive).
            let filePath = value.character_FilePath;

            const get = Lottie.loadAnimation({
                container: refnew.current,
                name: AnimationId,
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: filePath,
                rendererSettings: {
                    preserveAspectRatio: "xMidYMin meet",
                    viewBoxOnly: true,
                    progressiveLoad: true,
                }
            })
            //get.setDirection(-1)
            // get.addEventListener('config_ready', async function () {
            //     //yaha jo b kam karna hoga wo
            //     console.log(UnloadedCounter + " UnloadedCounter (character)");
            //     console.log(value.previewKey + " is loaded (character)");
            //     let array = Array.from(LoadCounter);
            //     array.push(value.previewKey);
            //     setLoadCounter(array);
            //     // setUnloadedCounter(UnloadedCounter - 1)
            //     get.removeEventListener('config_ready')
            // })
            setCanvChar(get)
            setchechState(false)
        }
        return () => {
            Lottie.destroy(AnimationId)
        }
    }, [value.character_FilePath])

    useEffect(() => {
        if (CanvasDisplay) {
            if (!chechState) {
                CanvChar.stop(AnimationId)
            }
        }
    }, [CanvasDisplay])

    useEffect(() => {
        if (player) {
            if (!chechState) {
                CanvChar.play(AnimationId);
            }
        }
        else if (!player) {
            if (!chechState) {
                CanvChar.stop(AnimationId)
            }
        }
    }, [player])

    return (
        <div className={(value.Editable == true ? 'RectBorder' : '')} id={AnimationId}
            style={{
                transform: "scaleX(1)", width: '100%',
                height: '100%', position: 'absolute', top: '0px', opacity: value.opacity, zIndex: - 1
            }}>
            <div ref={refnew} />
        </div>
    );
};
export default LottieTransitionLoader;